import React, { Component } from 'react';

import { connect } from 'react-redux';
import * as MailTemplate from './Saga/MailTemplate';
import * as Mail from '../Mail/Saga/Mail';
import * as Master from '../../Store/Master';

import '../../Css/Grid.css';

import IconButton from '@mui/material/IconButton';


import MuiButton from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import Card from '@mui/material/Card';

import './Css/Grid.css'




/**
 *会計連動グリッド
 *
 * @class AccountingGridComponent
 * @extends {Component<Props, State>}
 */
class MailGridComponent extends Component {
  constructor(props) {
    super(props);
    // this.onRowClick = this.onRowClick.bind(this);
    // this.onScroll = this.onScroll.bind(this);
    // this.togglesheet = this.togglesheet.bind(this);
    // this.getCellActions = this.getCellActions.bind(this);

    this.state = {
      modalsheet:false,
      mail_id:0,
      modal_new:false,
      modal_del:false,
      del_id:0,
      columnWidths:{
        id:100,
        category_name:370,
      },
      setDragIndex:null,
      sort_mode:true,
      tab:0,
      modal_koumoku:false,
      auto_send_mail_template_category_disp:false,

      edit_disp:false,
      edit_id:0,
      edit_name:0,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleDetailChange = this.handleDetailChange.bind(this);
    this.handleNewChangeUser = this.handleNewChangeUser.bind(this);
    this.handleDetailChangeUser = this.handleDetailChangeUser.bind(this);
    this.RowClick = this.RowClick.bind(this);
    this.handleCellClick = this.handleCellClick.bind(this);
    this._rowClassNameGetter = this._rowClassNameGetter.bind(this);
    this.handleClickMailTemplateSelect = this.handleClickMailTemplateSelect.bind(this);
    this.handleClickMailTemplateSave = this.handleClickMailTemplateSave.bind(this)
    this.handleClickMailTemplateSaveChangeName = this.handleClickMailTemplateSaveChangeName.bind(this)
    this.handleTabChange = this.handleTabChange.bind(this)
    this.CategoryUpdate = this.CategoryUpdate.bind(this)
    // this.props.get_mail_template_list(this.props.auto_send);
    this.props.get_auto_send_mail_template_category_list();
    // this.props.change_mail_template_details({id:0, template_name:"", subject:"", body_all_text:"", send_type:0, tab:0, is_text:0, mail_template_category_id:72, auto_send_mail_template_category_id:0, day_term:-1, time:0, section_id:this.props.user_details.amSectionId, user_id:0})
  }

  componentWillMount() {

  }

  handleChange = (event) => {
    // alert(event.target.name)
    console.log(event)
    // alert(event.target.name)
    // alert(event.target.value)
    let mail_template_form = this.props.mail_template_form

    mail_template_form[event.target.name] = event.target.value

    this.props.change_mail_template_form(mail_template_form)
    this.props.get_mail_template_list_search()

    this.setState({ reflash: !this.state.reflash });
  }

  handleChangeUser = (event, value) => {

    let mail_template_form = this.props.mail_template_form
    mail_template_form.user_id = value ? value.value : 0;

    this.props.change_mail_template_form(mail_template_form);
    this.props.get_mail_template_list_search()

    this.setState({ reflash: !this.state.reflash });
  }

  handleDetailChange = (event) => {
    // // alert(event.target.name)
    // console.log(event)
    // // alert(event.target.name)
    // // alert(event.target.value)
    // let mail_template_details = this.props.mail_template_details

    // mail_template_details[event.target.name] = event.target.value

    // if(event.target.name == "send_type"){
    //   mail_template_details.tab = event.target.value == 0 || event.target.value == 2 ? 0 :1
    // }

    // this.props.change_mail_template_details(mail_template_details)

    this.setState({ edit_name: event.target.value });

  }

  handleDetailChangeUser = (event, value) => {

    let mail_template_details = this.props.mail_template_details
    mail_template_details.user_id = value ? value.value : 0;

    this.props.change_mail_template_details(mail_template_details);
    this.props.get_mail_template_list_search()

    this.setState({ reflash: !this.state.reflash });
  }

  handleNewChangeUser = (event, value) => {

    this.setState({ user_id: value ? value.value : 0 });
    this.setState({ reflash: !this.state.reflash });
  }

  RowClick(event,index){
    // alert(index)

    // this.props.get_mail_template_details_new(this.props.auto_send_mail_template_category_list[index].id)

    this.setState({ edit_id: this.props.auto_send_mail_template_category_list[index].id,
      edit_name: this.props.auto_send_mail_template_category_list[index].category_name,
      edit_disp: true })
  }

  handleCellClick = (rowIndex) => {

    this.setState({ edit_id: this.props.auto_send_mail_template_category_list[rowIndex].id,
      edit_name: this.props.auto_send_mail_template_category_list[rowIndex].category_name,
      edit_disp: true })
  };

  CategoryUpdate(){

    if(this.state.edit_id > 0){
      this.props.update_auto_send_mail_template_category({id: this.state.edit_id, category_name: this.state.edit_name, section_id: this.props.mail_template_form.section_id})
    }else{
      this.props.insert_auto_send_mail_template_category({id:0, category_name: this.state.edit_name, section_id: this.props.mail_template_form.section_id})
    }
    this.setState({ "edit_disp": false })
  }
  

  _rowClassNameGetter(index){
        
    if(this.props.mail_template_list_search && this.props.mail_template_list_search[index]){

      if(this.props.mail_template_list_search[index].id == this.props.mail_template_details.id){
        return "select"
      }else{
        return "normal"
      }
    }else{
      return ""
    }
  }

  handleClickMailTemplateSelect(subject,body){


    let send_mail_details = this.props.send_mail_details;
    if(subject){
      send_mail_details.subject = subject;
    }
      
    // send_mail_details.htmlUtf8 = ""
    // send_mail_details.htmlUtf8 = this.props.mail_template_details.body_all;

    let editor = window.CKEDITOR.instances[Object.keys(window.CKEDITOR.instances)[0]];
            // editor.insertHtml(payload.html_utf8);
            editor.insertHtml(body);


    this.props.change_send_mail_details(send_mail_details)

    this.props.draggable === 1 ? this.props.change_draggable(2) : this.props.change_draggable(1)

    this.props.handleTemplateClose()
    this.setState({ refresh: !this.state.refresh })
  }

  dragStart(index){
    if(this.state.sort_mode){
    // alert(index)
    this.setState({ setDragIndex: index })
  }
  }


  dragEnter(index){
    // alert(index)
    // alert(this.state.setDragIndex)
    // alert(index)
    // console.log("dragEnter", this.state.setDragIndex, index)
    if(this.state.sort_mode){

      if (index === this.state.setDragIndex) return;


      let auto_send_mail_template_category_list = JSON.parse(JSON.stringify(this.props.auto_send_mail_template_category_list));
      const deleteElement = auto_send_mail_template_category_list.splice(this.state.setDragIndex, 1)[0];
      auto_send_mail_template_category_list.splice(index, 0, deleteElement);


      this.props.change_auto_send_mail_template_category_list(auto_send_mail_template_category_list)

      this.setState({ setDragIndex: index })
    }
  }

  dragEnd(){
    // alert("hozon")
    if(this.state.sort_mode){
      this.setState({ setDragIndex: null })
    }
  }

  handleClickMailTemplateSave(){

    if(parseInt(this.props.mail_template_details.mail_template_category_id) == 76){//自動追客
      if(this.props.mail_template_details.auto_send_mail_template_category_id <= 0){
        alert("追客対象を選択してください。")
        return
      }
      if(this.props.mail_template_details.day_term < 0){
        alert("反響登録時からの日数を選択してください。")
        return
      }
      if(this.props.mail_template_details.time == 0){
        alert("送信時間を選択してください。")
        return
      }
    }

    if(this.props.mail_template_details.id){
      // alert("update", this.props.mail_template_details.id)
      this.props.update_mail_template_details();
    }else{
      // alert("insert")
      this.props.insert_mail_template_details(this.props.mail_template_details)
    }
    this.setState({ "modalTemplateSave": true })
  }

  handleClickMailTemplateSaveChangeName(){

    if(parseInt(this.props.mail_template_details.mail_template_category_id) == 76){//自動追客
      if(this.props.mail_template_details.auto_send_mail_template_category_id <= 0){
        alert("追客対象を選択してください。")
        return
      }
      if(this.props.mail_template_details.day_term < 0){
        alert("反響登録時からの日数を選択してください。")
        return
      }
      if(this.props.mail_template_details.time == 0){
        alert("送信時間を選択してください。")
        return
      }
    }

    this.props.insert_mail_template_details(this.props.mail_template_details)

    this.setState({ "modalTemplateSave": true })

  }

  handleTabChange = (event, newValue) => {

    let mail_template_details = this.props.mail_template_details

    mail_template_details.tab = newValue

    this.props.change_mail_template_details(mail_template_details)

    this.setState({ refresh: this.state.refresh });
};

  paramset = (text) => {
    // let editor = window.CKEDITOR.instances.editor2;
    // let editor = window.CKEDITOR.instances[Object.keys(window.CKEDITOR.instances)[1]];

    // editor.insertHtml(text);
    // editor.insertText(text);
    // this.toggle()

    const mail_template_details = this.props.mail_template_details;

    const selectionStart = document.getElementById('body_all_text').selectionStart;

    // 現在のテキストを取得
    const currentText = mail_template_details.body_all_text;

    // カーソル位置に文字を挿入
    const newText = currentText.substring(0, selectionStart) + text + currentText.substring(selectionStart);

    // テキストフィールドを更新
    mail_template_details.body_all_text = newText;

    this.props.change_mail_template_details(mail_template_details)

    this.setState({ modal_koumoku: !this.state.modal_koumoku, reflash: !this.state.refrlash });

      // // カーソル位置を更新
      // const newCursorPosition = selectionStart + textToInsert.length;
      // textField.setSelectionRange(newCursorPosition, newCursorPosition);

  }


  render() {

    return (
      <div style={{padding:"0px 20px 0px 20px"}}>
        <div style={{display: "flex"}}>
          <Card style={{padding:20, width:500}}>

          <Grid container spacing={3}>


          <Grid xs={12} style={{padding:5}}>
          <MuiButton variant="contained" onClick={(e) => { this.setState({ edit_id: 0, edit_name: "", edit_disp: true });}} >追加</MuiButton>
            <Table
              className="gridMailTemplateSearchList"
              rowHeight={36}
              rowsCount={this.props.auto_send_mail_template_category_list.length} 
              width={440}
              // height={150}
              height={window.innerHeight - 390}
              headerHeight={34}
              // onColumnResizeEndCallback={this._onColumnResizeEndCallback}
              isColumnResizing={false}
              rowClassNameGetter={this._rowClassNameGetter}
              // onRowClick={this.RowClick}
              
            >

              <Column width={this.state.columnWidths.category_name} isResizable={true} columnKey="name" header={<Cell>追客区分名</Cell>} cell={({ rowIndex, ...props }) => (<Cell 
                          // draggable={this.state.sort_mode && this.props.mail_template_form.category > 0 && this.props.mail_template_form.user_id == 0} 
                          onClick={()=>this.handleCellClick(rowIndex)}
                          draggable={true}
                          onDragStart={() => this.dragStart(rowIndex)}
                          onDragEnter={() => this.dragEnter(rowIndex)}
                          onDragOver={(event) => event.preventDefault()}
                          onDragEnd={() => this.dragEnd()}
                          className={rowIndex === this.state.setDragIndex ? 'dragging' : ''}
                {...props}>
                  {this.props.auto_send_mail_template_category_list[rowIndex].category_name}
              </Cell>)} />
              <Column width={80} isResizable={false} header={<Cell>削除</Cell>} cell={({ rowIndex, ...props }) => (<Cell {...props}
                                      // draggable={this.state.sort_mode && this.props.mail_template_form.category > 0 && this.props.mail_template_form.user_id == 0} 
                                      draggable={true}
                                      onDragStart={() => this.dragStart(rowIndex)}
                                      onDragEnter={() => this.dragEnter(rowIndex)}
                                      onDragOver={(event) => event.preventDefault()}
                                      onDragEnd={() => this.dragEnd()}
                                      className={rowIndex === this.state.setDragIndex ? 'dragging' : ''}
              >
                  <IconButton
                    onClick={(e)=>{this.setState({ "modal_del": true, "del_id":this.props.auto_send_mail_template_category_list[rowIndex].id })}}
                    style={{padding:2}}
                    size="large"><DeleteIcon /></IconButton>
              </Cell>)} />

            </Table>

            </Grid>
            <Grid xs={12} style={{padding:5}}>
              {/* {this.props.mail_template_form.category > 0 && this.props.mail_template_form.user_id == 0 && !this.state.sort_mode ? <MuiButton variant="contained" onClick={(e) => { this.setState({ "sort_mode": true });}} style={{backgroundColor:"#ffc400", border:"#dc3545", float:"right"}}>並び替え</MuiButton>:""} */}
              {this.state.sort_mode ? <MuiButton variant="contained" onClick={(e) => { this.props.update_auto_send_mail_template_category_sort();this.setState({"modalTemplateSave":true})}} style={{backgroundColor:"#ffc400", border:"#dc3545", float:"right"}}>並び替え保存</MuiButton>:""}
              {/* {this.props.mail_template_form.category > 0 && this.props.mail_template_form.user_id == 0 && this.state.sort_mode ? <MuiButton variant="contained" onClick={(e) => { this.setState({ "sort_mode": false });this.props.get_mail_template_list_search()}} style={{backgroundColor:"#bdbdbd", border:"#dc3545", float:"right", marginRight:5}}>並び替え解除</MuiButton>:""} */}

          
            </Grid>
          </Grid>
          </Card>

        </div>

        <Dialog open={this.state.modal_new} style={{zIndex:1052}} maxWidth="sm" fullWidth={true} onClose={(e) => { this.setState({ "modal_new": false });}}>
          <DialogTitle>
            新しいテンプレートを追加する
            <IconButton
              aria-label="close"
              onClick={(e) => { this.setState({ "modal_new": false }); }}
              style={{float: 'right'}}
              size="large">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <div style={{padding:20}}>
          <Grid container spacing={3}>
            <Grid xs={6} style={{ padding: "0px 5px" }}>
              <TextField
                style={{width:280, marginTop:3}}
                // onChange={this.handleDetailChange}
                onChange={(e) => { this.setState({ "template_name": e.target.value }); }}
                value={this.state.template_name}
                margin="dense"
                label="テンプレート名"
                name="template_name"
                variant="standard"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid xs={6} style={{ padding: "0px 5px" }}>
              {/* <span>{this.props.mail_template_details.mail_template_category_id}</span> */}
              <FormControl variant="standard" style={{width:250}}>
                <InputLabel id="sectionId-label">カテゴリー</InputLabel>
                <Select
                    id="mail_template_category_id"
                    name="mail_template_category_id"
                    value={parseInt(this.state.mail_template_category_id)}
                    // onChange={this.handleDetailChange}
                    onChange={(e) => { this.setState({ "mail_template_category_id": e.target.value }); }}
                    label="mail_template_category_id"
                    size="small"
                    
                    InputLabelProps={{ shrink: true }}
                >
                    {this.props.mail_template_categories.filter(a=>a.display == 100).map(function (item, i) {
                    return (
                        <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                    );

                    })}

                </Select>
              </FormControl>
            </Grid>

          {this.state.mail_template_category_id == 76 ? <Grid xs={12} style={{ padding: "0px 5px" }}>
            <FormControl variant="standard" style={{width:250}} >
              <InputLabel id="sectionId-label">追客区分</InputLabel>
              <Select
                  id="auto_send_mail_template_category_id"
                  name="auto_send_mail_template_category_id"
                  value={this.state.auto_send_mail_template_category_id}
                  onChange={(e) => { this.setState({ "auto_send_mail_template_category_id": e.target.value }); }}
                  label="auto_send_mail_template_category_id"
                  size="small"
                  InputLabelProps={{ shrink: true }}
              >
                  <MenuItem key={-1} value={0}></MenuItem>
                  {/* {this.props.section_select.filter(a => a.value > 0 && a.value <=6 || a.value == 10 || a.value == 16 || a.value == 17 || a.value == 26 || a.value == 37 || a.value == 47).map(function (item, i) { */}
                  {this.props.mail_template_categories.filter(a=>a.display == 200).map(function (item, i) {
                  return (
                      <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                  );

                  })}

              </Select>
            </FormControl>
          </Grid>:""}

            <Grid xs={6} style={{ padding: "0px 5px" }}>
            {/* <span>{this.props.mail_template_details.section_id}</span> */}
              <FormControl variant="standard" style={{width:160}}>
                <InputLabel id="sectionId-label">店舗</InputLabel>
                <Select
                    labelId="sectionId-label"
                    id="section_id"
                    name="section_id"
                    value={parseInt(this.state.section_id)}
                    // onChange={this.handleDetailChange}
                    onChange={(e) => { this.setState({ "section_id": e.target.value }); }}
                    label="section_id"
                    size="small"
                    
                    InputLabelProps={{ shrink: true }}
                >
                    {this.props.shops.sort((a, b) => {return a.dispOrder < b.dispOrder ? -1 : 1;}).map(function (item, i) {
                    return (
                        <MenuItem key={i} value={item.tenpoNo}>{item.tenpoNo == -1 ? "共通" : item.tenpoName}</MenuItem>
                    );

                    })}

                </Select>
              </FormControl>
            </Grid>
            <Grid xs={6} style={{ padding: "0px 5px" }}>
              <Autocomplete
                id="combo-box-demo"
                size="small"
                options={this.props.users_select.length === 0 && this.state.user_id ? [this.props.users_select.filter(a => a.value === this.state.user_id)[0]]
                    : this.props.users_select}
                getOptionLabel={(option) => option.label ? option.label : ''}

                style={{ width: "140px" }}
                name="user_id"
                loading={this.props.users_loading}

                value={this.state.user_id ? this.props.users_select.filter(a => a.value === this.state.user_id)[0] : {}}

                onChange={this.handleNewChangeUser}

                renderInput={(params) => <TextField
                    {...params}
                    variant="standard"
                    name="user_id"

                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>

                                {this.props.rent_m_corporates_loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    // onChange={this.change_response_user_id}
                    label="担当" />}

              />

            </Grid>
            
            
          </Grid>
          </div>

          <DialogActions>
            <MuiButton variant="contained" style={{backgroundColor:"#e0e0e0", color:"black"}} onClick={(e) => { this.setState({ "modal_new": false });}} >キャンセル</MuiButton>
            <MuiButton variant="contained" onClick={()=>{this.props.insert_mail_template_details({template_name:this.state.template_name, mail_template_category_id:this.state.mail_template_category_id, auto_send_mail_template_category_id:this.state.auto_send_mail_template_category_id, day_term:-1, time:0, section_id:this.state.section_id, user_id:this.state.user_id});this.setState({ "modal_new": false })}} style={{backgroundColor:"#5cb85c", color:"white"}} color="success">保存</MuiButton>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.modal_del} style={{zIndex:1052}} maxWidth="sm" fullWidth={true} onClose={(e) => { this.setState({ "modal_del": false, "del_id":0 });}}>
          <DialogTitle>
            削除してよろしいですか？
            <IconButton
              aria-label="close"
              onClick={(e) => { this.setState({ "modal_del": false, "del_id":0 }); }}
              style={{float: 'right'}}
              size="large">
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogActions>
            <MuiButton variant="contained" style={{backgroundColor:"#e0e0e0", color:"black"}} onClick={(e) => { this.setState({ "modal_del": false, "del_id":0 });}}>キャンセル</MuiButton>
            <MuiButton variant="contained" onClick={()=>{this.props.delete_auto_send_mail_template_category({id: this.state.del_id});this.setState({ "modal_del": false, "del_id":0 })}} style={{backgroundColor:"#dc3545", border:"#dc3545", color:"white"}} color="success">削除</MuiButton>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.modalTemplateSave } style={{zIndex:1052}} onClose={(e) => { this.setState({ "modalTemplateSave": false });}}>
                <DialogTitle>
                  保存しました。
                </DialogTitle>
                {/* <DialogActions>
                  <ButtonMui variant="contained" color="inherit" onClick={()=>this.setState({ "modalTemplateSave": false })}>閉じる</ButtonMui>
                </DialogActions> */}
              </Dialog>

        <Dialog open={this.state.edit_disp } style={{zIndex:1052}} onClose={(e) => { this.setState({ "edit_disp": false });}} maxWidth="md">
          <DialogTitle>
            自動送信対象区分名
          </DialogTitle>
          <DialogContent style={{padding:10}}>
            <TextField
              fullWidth
              onChange={this.handleDetailChange}
              value={this.state.edit_name}
              size="small"
              label="自動送信対象区分名"
              name="edit_name"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
            />
          </DialogContent>
          <DialogActions>
            {/* <MuiButton variant="contained" style={{backgroundColor:"#e0e0e0", color:"black"}} onClick={(e) => { this.setState({ "modal_new": false });}} >キャンセル</MuiButton> */}
            <MuiButton variant="contained" onClick={this.CategoryUpdate} style={{backgroundColor:"#5cb85c", color:"white"}} color="success">保存</MuiButton>
          </DialogActions>
          
        </Dialog>

              

        <div>

        </div>
      </div>
    );
  }


}



const mapStateToProps = (state) => {
  return {

    mails: state.mailReducer.mails,
    mail_loading: state.mailReducer.mail_loading,
    shops: state.masterReducer.shops,
    users_select: state.masterReducer.users_select,
    user_details: state.masterReducer.user_details,
    mail_template_form: state.mailtemplate.mail_template_form,
    mail_template_categories: state.mailtemplate.mail_template_categories,
    mail_template_list_search: state.mailtemplate.mail_template_list_search,
    mail_template_details: state.mailtemplate.mail_template_details,
    
    auto_send_mail_template_category_list: state.mailtemplate.auto_send_mail_template_category_list,
    // response_mail_loading: state.mailReducer.response_mail_loading,

    send_mail_details: state.mailReducer.send_mail_details,
    draggable: state.masterReducer.draggable,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    // get_mails(state: any) {
    //   dispatch(Mail.get_mails(state))
    // },
    // add_mails(state) {
    //   dispatch(Mail.add_mails(state))
    // },
    change_mail_template_form(state) {
      dispatch(MailTemplate.change_mail_template_form(state))
    },
    get_mail_template_list(state) {
      dispatch(MailTemplate.get_mail_template_list(state))
    },
    get_mail_template_categories(state) {
      dispatch(MailTemplate.get_mail_template_categories(state))
    },
    get_mail_template_list_search(state) {
      dispatch(MailTemplate.get_mail_template_list_search(state))
    },
    update_mail_template_list_sort(state) {
      dispatch(MailTemplate.update_mail_template_list_sort(state))
    },
    change_mail_template_details(state) {
      dispatch(MailTemplate.change_mail_template_details(state))
    },
    get_mail_template_details_new(state) {
      dispatch(MailTemplate.get_mail_template_details_new(state))
    },
    insert_mail_template_details(state) {
      dispatch(MailTemplate.insert_mail_template_details(state))
    },
    delete_mail_template_details(state) {
      dispatch(MailTemplate.delete_mail_template_details(state))
    },
    change_mail_template_list_search(state) {
      dispatch(MailTemplate.change_mail_template_list_search(state))
    },
    
    change_send_mail_details(state) {
      dispatch(Mail.change_send_mail_details(state))
    },
    change_draggable(state) {
      dispatch(Master.change_draggable(state))
    },
    update_mail_template_details(state) {
      dispatch(MailTemplate.update_mail_template_details(state))
    },
    get_auto_send_mail_template_category_list(state) {
      dispatch(MailTemplate.get_auto_send_mail_template_category_list(state))
    },
    insert_auto_send_mail_template_category(state) {
      dispatch(MailTemplate.insert_auto_send_mail_template_category(state))
    },
    update_auto_send_mail_template_category(state) {
      dispatch(MailTemplate.update_auto_send_mail_template_category(state))
    },
    delete_auto_send_mail_template_category(state) {
      dispatch(MailTemplate.delete_auto_send_mail_template_category(state))
    },
    change_auto_send_mail_template_category_list(state) {
      dispatch(MailTemplate.change_auto_send_mail_template_category_list(state))
    },
    update_auto_send_mail_template_category_sort(state) {
      dispatch(MailTemplate.update_auto_send_mail_template_category_sort(state))
    },
    
    // insert_mail_template_details(state) {
    //   dispatch(MailTemplate.insert_mail_template_details(state))
    // },
  };
}



// const mapStateToProps = (state:any) => {
//     return {
//         rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
//         shops: state.masterReducer.shops,
//     }
// }
// function mapDispatchToProps(dispatch:any) {
//     return {
//         get_rent_contracts_list(state:any) {
//             dispatch(Contracts.get_rent_contracts_list(state))
//         },


//     };
// }

export default connect(mapStateToProps, mapDispatchToProps)(MailGridComponent);